let PRODUCT = {};

function setButtonText(step) {
  const $button = $("form[action='/cart/add'] button.add_to_cart");
  let text = $button.data("continue");
  const steps = $(".progress").find("li").length - 1;
  if (step === steps) {
    text = $button.data("label");
  }
  $button.find(".text").text(text);
}

function setProgress(step) {
  const $progress = $(".progress");
  $progress.find(`li:gt(${step})`).removeClass("active")
  $progress.find("li").eq(step).addClass("active");
  $progress.data("progress", step);

  setButtonText(step)

  $(`[data-step]`).removeClass("active").eq(step).addClass("active");
}

function onProgressClick(e) {
  e.preventDefault();
  
  const $parent = $(e.target).parent();
  const active = $parent.hasClass("active");
  if (active) {
    setProgress($parent.index());
  }
}

function onReorderChange(e) {
  e.preventDefault();

  // const checked = $(e.target).is(":checked");
  // $("[name='properties[_prepay]']").prop("checked", checked);

  $("tr.custom-art-fee").toggleClass("hidden");
  $("tr.waived-artwork-fee").toggleClass("hidden");

  // $(".artwork-not-reused").toggleClass("hidden");
  setTotal();
}

function asCurrency(number) {
  let v = number / 100;
  if (isNaN(v)) {
    v = 0;
  }

  return v.toLocaleString("en-US", {
    currency: "USD",
    style: "currency",
  });
}

function asValue(str) {
  return parseInt(str.replace(/[^0-9]/g, ""));
}

function setTooltip($range, price) {
  const val = $range.val();
  const min = $range.attr("min") || 0;
  const max = $range.attr("max") || 100;
  const pos = Number(((val - min) * 100) / (max - min));
  const magic = 8 - pos * 0.175;
  const left = `calc(${pos}% + ${magic}px`;

  $(".custom.tooltip").addClass("active").css("left", left).text(asCurrency(price));
}

function getVariant(val) {
  const variant = PRODUCT.variants.reduce((o, v, i, s) => {
    let end = -1;
    if (i + 1 < s.length) {
      end = s[i + 1].title;
    }
    const start = v.title;

    if (val >= start && (end == -1 || val <= end)) {
      return [i, v.price];
    }

    return o;
  }, []);

  if (variant.length === 0) {
    return [0, PRODUCT.variants[0].price];
  }

  return variant;
}

function setTotal() {
  const qty = parseInt($("[name='properties[quantity]'][type='number']").val());
  const [, price] = getVariant(qty);
  
  let total = 0;
  const $prepay = $("[name='properties[_prepay]']");
  if($prepay.is(":checked")) {
    total = qty * price;
  }


  const $serial = $("[name='properties[_serial_number_id]']");
  if ($serial.is(':checked') && $prepay.is(":checked")) {
    total += (parseInt($serial.data("price")) * qty);
  }
  
  const $reorder = $("[name='properties[reorder]']");
  if (!$reorder.is(":checked")) {
    total += parseInt($reorder.data("price"));
  }

  const $sample = $("[name='properties[sample]']");
  if ($sample.is(":checked")) {
    total += parseInt($sample.data("price"));
  }

  $("[name='properties[_price]").val(asCurrency(price));
  $("table.summary").find(".total").text(asCurrency(total));
  $("[name='properties[_total]']").val(asCurrency(total));
}

function onQuantityChange(e) {
  let val = parseInt(e.target.value);

  const $number = $("[name='properties[quantity]'][type='number']");
  if (e.target.name !== "properties[quantity]") {
    val = parseInt($number.val());
  }
  $number.attr("size", val.toString().length);

  const $range = $("[type=range][name='properties[quantity]']");
  if (e.target.type !== "range") {
    $range.val(val);
  }

  let [index, price] = getVariant(val);

  $("select[name='properties[id]'] option")
    .attr("selected", null)
    .eq(index)
    .attr("selected", "selected");

  if (val >= $("[data-custom-min]").data('custom-min')) {
    $("table.pricing tbody tr").removeClass("active").eq(index).addClass("active");
  }

  const $summary = $("table.summary");
  $summary.find("td.price").text(asCurrency(price));
  $summary.find("td.quantity").text(
    val.toLocaleString("en-US", { maximumFractionDigits: 0 })
  );

  setTooltip($range, price);

  const $serialProduct = $summary.find("tr.serial-product");
  let serialPrice = 0;
  const $serial = $("[name='properties[_serial_number_id]']");
  if ($serial.is(':checked')) {
    serialPrice = parseInt($serial.data("price"));
    $serialProduct.removeClass("hidden");
  } else {
    $serialProduct.addClass("hidden");
  }
  price += serialPrice;

  $("[name='properties[_price]']").val(asCurrency(price));

  setTotal();
  let total = val * price;

  $number.val(val);

  let unit = $("[name='properties[quantity]']").data("unit");

  $(".custom.price.quantity .quantity .unit").text(val === 1 ? unit : unit +"s");

  let originalPrice = parseInt($(".product_custom_form").data("price"));
  originalPrice += serialPrice;

  const $custom = $(".custom.price.quantity");
  const $saving = $(".custom.saving");
  const originalTotal = val * originalPrice;
  if (total !== originalTotal) {
    $custom.find(".price .was").text(asCurrency(originalTotal));

    const saving = Math.round(((originalPrice - price) / originalPrice) * 100);
    $saving.removeClass("hidden").find(".value").text(saving);
  } else {
    $custom.find(".price .was").text("");
    $saving.addClass("hidden");
  }
  if (total === 0) {
    total = 1 * originalPrice;
  }
  $custom.find(".price .is").text(asCurrency(total));
}

function notify(message, type = "error") {
  const $notification = $(".custom.notification");
  $notification.removeClass("hidden").addClass(type);
  $notification.find(".text").text(message);
  $notification.find(".close").on("click", () => {
    $notification.addClass("hidden").removeClass(type);
  })
}

function validateFileSize(file) {
  const size = (file.size / 1e+6).toFixed(2); // mb
  return size < 20;
}

function validateFileType(file) {
  const type = file.type;
  return [
    "application/illustrator", "application/x-indesign", "application/x-adobe-indesign", "application/octet-stream", "application/x-photoshop", // adobe .[ai,indd,psd]
    "application/pdf",
    "application/postscript",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-word", "application/msword",
    "application/vnd.openxmlformats-officedocument.", // .xlsx, .docx, .pptx, ...
    "application/vnd.ms-publisher",
    "application/zip", // .sketch
    "image/",
    "vnd.apple.keynote",
    "vnd.apple.numbers",
    "vnd.apple.pages"
  ].some((ext) => type.startsWith(ext));
}

function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function() { resolve(reader) };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  }, []);
}

function type(file) {
  const types = {
    indd: "application/octet-stream",
    sketch: "application/zip",
  }
  const ext = file.name.split('.').at(-1);
  if (Object.keys(types).includes(ext)) {
    return types[ext];
  }
  return file.type;
}

async function onFileChange(e) {
  e.preventDefault();

  const blob = e.target.files[0];
  const file = new File([blob], blob.name, { type: type(blob) })
  console.log({ blob, file });

  if (!validateFileSize(file)) {
    notify("File size to large (max 20MB)");
    return;
  }

  if (!validateFileType(file)) {
    notify("Unsupported file type, if the problem persists please email to the uploads to gene@combatbet.com");
    return;
  }
  
  try {
    const reader = await readFile(file);
    if (reader.result.startsWith("data:image/")) {
      $("table.summary td.icon img").attr("src", reader.result);
    } else {
      $("table.summary td.icon img").attr("src", $("table.summary td.icon img").data("default"));
    }

    const $input = $(e.target);
    const $parent = $input.parent();
    const $clone = $parent.clone(true);
    $clone.find("[type='file']").val("");
    $clone.insertAfter($parent);
  } catch(err) {
    notify("Unable to read file, if the problem persists please email to the uploads to gene@combatbet.com");
    console.error(err);
  }
}

function onFileRemove(e) {
  e.preventDefault();
  
  $(e.target).parent().remove();
}

function onNoteChange(e) {
  e.preventDefault();

  $("table.summary .notes").text(e.target.value);
}

function setRowSpan() {
  const $summary = $("table.summary");
  const rowspan = $summary.find("tbody tr").filter((i, el) => !$(el).hasClass("hidden")).length;
  $summary.find("td.icon").attr("rowspan", rowspan);
}

function onSampleChange(e) {
  e.preventDefault();

  $(".sample-coin-fee").toggleClass("hidden");

  setRowSpan();

  setTotal();
}

function onPrepayChange(e) {
  e.preventDefault();

  $(".coins-line-item").toggleClass("hidden");
  $(".waived-artwork-fee .notes").toggleClass("hidden");

  const $serial = $("[name='properties[_serial_number_id]']");
  if ($serial.is(':checked')) {
    $(".serial-product").toggleClass("hidden");
  }


  setRowSpan();

  setTotal();
}



const RECAPTCHA_KEY = "6Lfi-EcqAAAAABExYMLi9KhMB3hihaOKKxWtQPSg";
const RECAPTCHA_URL = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`;

function recaptcha() {
  return new Promise((resolve, reject) => {
    const d = window.document;
    const e = d.querySelector(`script[src='${RECAPTCHA_URL}']`);
    if (e) {
      // script already loaded
      const id = setInterval(() => {
        if ("grecaptcha" in window) {
          resolve(window.grecaptcha);
          clearInterval(id);
        }
      }, 250);
      return;
    }

    const s = d.createElement("script");
    s.onload = () => {
      const id = setInterval(() => {
        if ("grecaptcha" in window) {
          window.grecaptcha.ready(() => resolve(window.grecaptcha));
          clearInterval(id);
        }
      }, 250);
    };
    s.onerror = (e) => reject(e);
    s.src = RECAPTCHA_URL;
    s.type = "text/javascript";

    const t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
  });
}

async function updateMiniCart() {
  const cart = await window.fetch("/cart.js");
  if (!cart.ok) {
    return;
  }

  const data = await cart.json();

  const $cart = $(".cart-container");
  const $form = $cart.find("form");
  $form.find("ul.cart_items").empty();
  $form.removeClass("hidden");

  $(".js-empty-cart__message").addClass("hidden");

  data.items.map((item, index) => {
    $form.find("ul.cart_items").append(`
      <li class="mini-cart__item" data-cart-item="" data-line-id="${index + 1}" data-variant-id="${item.variant_id}">
        <a href="${item.url}">
          <div class="cart_image mini-cart__item-image">
            <img src="${item.image}" />
          </div>
        </a>

        <div class="mini-cart__item--content">
          <div class="mini-cart__item__title">
            <div class="item_title">
              <a href="${item.url}">${item.title}</a>
            </div>
            ${item.properties && item.properties._title ? `<i>${item.properties._title}</i>` : ''}
          </div>

          <strong class="left price">
            <span class="money ">${asCurrency(item.quantity * item.price)}</span>
          </strong>

          <div class="left product-quantity-box">
            <span class="ss-icon product-minus js-change-quantity" data-func="minus">
              <span class="icon-minus"></span>
            </span>
            <input type="number" min="0" size="2" class="quantity" name="updates[]" id="updates_${item.variant_id}" value="${item.quantity}" data-cart-quantity-input="mini-cart">
            <span class="ss-icon product-plus js-change-quantity" data-func="plus">
              <span class="icon-plus"></span>
            </span>
          </div>
        </div>

        <a href="/cart/change?line=${index + 1}&amp;quantity=0" class="cart__remove-btn" data-line-id="${index + 1}" data-remove-item="mini-cart">
          <span class="remove-icon"></span>
        </a>
      </li>
    `);
  });

  $cart.find(".cart_subtotal").html(`
    <span class="right">
      <span class="money">
        ${asCurrency(data.items_subtotal_price)}
      </span>
    </span>
    <span>Subtotal</span>
  `);

  $cart.addClass("active_link");
}

function reset() {
  setProgress(0);

  const $button = $("form[action='/cart/add'] button.add_to_cart");
  $button.removeClass("active loading").find(".text").text($button.data("continue"));

  $("table.pricing tbody tr").removeClass("active");
  
  $(".artwork-not-reused").removeClass("hidden");

  $("form[action='/cart/add']").trigger("reset");

  $("[name='properties[quantity]']").val(1).trigger("change");

  $("[name='artwork[]']:gt(0)").remove();
}

async function onSubmit(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  // $("form[action='/cart/add']")[0].scrollIntoView({ behavior: "smooth" });
  
  if ($("[data-custom-min]").data('custom-min') > $("[name='properties[quantity]'][type='number']").val()) {
    $(".custom.price.quantity .quantity").addClass("error");
    return;
  } else {
    $(".custom.price.quantity .quantity").removeClass("error");
  }

  const $button = $("form[action='/cart/add'] button.add_to_cart");
  $button.addClass("active loading");

  const $progress = $(".progress");
  const steps = $progress.find("li").length - 1;
  let step = $progress.data("progress");

  const $step = $("[data-step]");
  $step.removeClass("active");
  if (step < steps) {
    step += 1;

    setRowSpan();

    $(".sticky_nav").removeClass("sticky_nav--stick").addClass("sticky_nav--unstick");

    setTimeout(() => {
      setProgress(step);
      $button.removeClass("loading");
    }, 750);

    return;
  }

  let cart = await window.fetch("/cart.js");
  if (!cart.ok) {
    console.error(err);

    notify("Unable to update cart, please retry");

    return;
  }
  cart = await cart.json();

  const captcha = await recaptcha();

  const id = $("[name='properties[id]']").val();
  const reorder = $("[name='properties[reorder]']").is(":checked");
  const prepay = $("[name='properties[_prepay]']").is(":checked");
  const quantity = $("[name='properties[quantity]']").val();
  const $serial = $("[name='properties[_serial_number_id]']");
  const files = Array.from($("[name='artwork[]']")).reduce(
    (files, file) => {
      const v = $(file).prop("files")[0];
      if (v) {
        files.push(v);
      }
      return files;
    },
    []
  );
  try {
    const $sample = $("[name='properties[sample]']");

    let uploads = [];
    if (files.length > 0) {
      uploads = await Promise.all(
        [...files].map(async (file, i) => {
          const token = await captcha.execute(RECAPTCHA_KEY, { action: "submit" });

          const ext = file.name.split(".").pop();
          const name = `${cart.token}-${id}-${i}.${ext}`

          const body = new FormData();
          body.set("token", token);
          body.set("file", new File([file], name, { type: file.type }));

          const req = await window.fetch("/apps/upload", {
            body,
            method: "POST",
          });
          if (!req.ok) {
            throw new Error("Error uploading your file, please retry.");
          }
          return req.json();
        })
      );
    }
    
    const body = {
      id: $("[name='id']").val(),
      properties: {
        _custom: true,
        _title: $("[name='properties[_title]']").val(),
        _prepay: prepay,
        _price: $("[name='properties[_price]']").val(),
        _total: $("[name='properties[_total]']").val(),
        artwork: null,
        id,
        quantity,
        notes: $("[name='properties[notes]']").val(),
        reorder,
        sample: $sample.is(":checked"),
      },
      quantity: $("[name='quantity']").val(),
    }
    
    if ($serial.is(':checked')) {
      body.properties._serial_number_id = $serial.val();
    }
    
    if (uploads.length > 0) {
      uploads.forEach((upload, i) => {
        if (i === 0) {
          body.properties[`artwork`] = upload.data.url;
        } else {
          body.properties[`_artwork_${i}`] = upload.data.url;
        }
      });
    }
    
    if (!reorder) {
      if ($serial.is(':checked')) {
        body.properties._serial_number_id = $serial.val();
      }

      req = await window.fetch("/cart/add.js", {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!req.ok) {
        throw new Error("Error updating your cart, please retry.");
      }
    }
    
    if ($sample.is(":checked")) {
      body.id = $sample.data("id");
      body.quantity = 1;
      
      req = await window.fetch("/cart/add.js", {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!req.ok) {
        throw new Error("Error updating your cart, please retry.");
      }
    }
    
    if (prepay) {
      if ($serial.is(':checked')) {
        body.id = $serial.val();
        body.quantity = quantity;
        
        req = await window.fetch("/cart/add.js", {
          body: JSON.stringify(body),
          headers: { "Content-Type": "application/json" },
          method: "POST",
        });
        if (!req.ok) {
          throw new Error("Error updating your cart, please retry.");
        }
      }
      
      body.id = id;
      body.quantity = quantity;
      
      req = await window.fetch("/cart/add.js", {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!req.ok) {
        throw new Error("Error updating your cart, please retry.");
      }
    } else if (reorder) {
      body.id = $("[name='_id']").val();
      body.quantity = 1;
      
      req = await window.fetch("/cart/add.js", {
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!req.ok) {
        throw new Error("Error updating your cart, please retry.");
      }
    }
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    await updateMiniCart();
    reset();
    
    notify("Custom coin added to cart", "success");
  } catch(e) {
    notify(e.message + " if the problem persists please email to the uploads to gene@combatbet.com");
    reset();
  }
}

function onLoad() {
  PRODUCT = Object.freeze($(".product_custom_form").data("product"));

  
  $("[name='properties[quantity]']").on("input change", onQuantityChange);

  if (!$(".product_custom_form").data("custom")) {
    return;
  }

  $("[name='properties[quantity]']").trigger("change");


  $(".progress a").on("click", onProgressClick);


  $("[name='properties[quantity]']").on("input change", onQuantityChange);
  $("[name='properties[_serial_number_id]']").on("change", onQuantityChange);
  $("[name='artwork[]']").on("change", onFileChange);
  $("[name='properties[notes]']").on("change", onNoteChange);
  $("[name='properties[reorder]']").on("change", onReorderChange);
  $("[name='properties[sample]']").on("change", onSampleChange);
  $("[name='properties[_prepay]']").on("change", onPrepayChange);


  $(".product-artwork button.remove").on("click", onFileRemove);
  
  const $form = $("form[action='/cart/add']");
  $form.on("submit", onSubmit);

  const $button = $form.find("button.add_to_cart");
  $button.data("continue", "Continue").find(".text").text($button.data("continue"));
  $button.on("click", onSubmit);
  $button.removeClass("hide");
}

window.addEventListener("load", onLoad);

